import { createGlobalStyle, css } from 'styled-components';

export const EditorRebootReverse = css`
  h1.editor-node,
  h2.editor-node,
  h3.editor-node,
  h4.editor-node,
  h5.editor-node,
  h6.editor-node {
    margin-top: revert;
    margin-bottom: revert;
    word-break: initial;
  }

  p.editor-node {
    margin-top: revert;
    margin-bottom: revert;
    word-break: initial;
  }

  img.editor-node {
    vertical-align: revert;
  }
`;

export default createGlobalStyle`
  ${EditorRebootReverse}
`;
